export default {
  "content": "<path fill=\"none\" d=\"M0 0h16v16H0z\" data-name=\"Bounding box\"/><g data-name=\"Isolation Mode\"><path d=\"M15 1H1a1 1 0 000 2v11a1 1 0 002 0V8.456A.456.456 0 013.456 8h9.088a.456.456 0 01.456.456V14a1 1 0 002 0V3a1 1 0 000-2z\" fill=\"#3f4450\"/><path d=\"M9.227 6h-2a1 1 0 010-2h2a1 1 0 010 2z\" fill=\"#fff\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 16 16"
  }
};